import { NewDynamicTab } from "../../../components/Page";
import { GridcoPowerProcurementDefaultDates } from "../../../config/DefaultDates";
import { GridcoTitle } from "../components";
import { TabSwitcher } from "../Gridco_Das";
import Collective from "./Collective";
import GridcoGnaTgna from "./GnaTgna";
import GridcoProcurementOverview from "./Overview";
import GridcoTrendProcurement from "./TrendAnalysis";

export function GridcoPowerProcurement() {
  return (
    <NewDynamicTab
      trendTabs={["Trend Analysis"]}
      defaultDates={GridcoPowerProcurementDefaultDates}
      header="Power Procurement"
      headerPrefixComponent={<TabSwitcher />}
      middleComponent={<GridcoTitle />}
      tabs={{
        Overview: <GridcoProcurementOverview />,
        "Trend Analysis": <GridcoTrendProcurement />,
        Collective: <Collective />,
        "GNA/TGNA": <GridcoGnaTgna />,
      }}
      disabledTabs={["GNA/TGNA"]}
    />
  );
}
